import { useDisclosure } from '@mantine/hooks';
import { createContext, useContext, useMemo, useState } from 'react';
import TableProfilesModal from 'components/modals/table-profiles-modal/TableProfilesModal';
import { TableProfilesModalProps } from 'components/modals/table-profiles-modal/TableProfilesModal';

type OpenTableProfilesModalParams = Omit<TableProfilesModalProps, 'opened' | 'onClose'>;
type OpenTableProfilesModal = (params?: OpenTableProfilesModalParams) => void;

interface ITableProfilesModalContext {
  openTableProfilesModal: OpenTableProfilesModal;
}

const TableProfilesModalContext = createContext<ITableProfilesModalContext>(undefined!);

/**
 * Provider for marking the device's fault as fixed.
 */
export function TableProfilesModalProvider({ children }: { children: React.ReactNode }) {
  const [opened, { close, open }] = useDisclosure(false);
  const [params, setParams] = useState<OpenTableProfilesModalParams | undefined>(undefined);

  /**
   * Opens the modal for copying table profiles.
   */
  const openTableProfilesModal: OpenTableProfilesModal = (params) => {
    setParams(params);
    open();
  };

  const value = useMemo(() => ({ openTableProfilesModal }), [openTableProfilesModal]);

  return (
    <TableProfilesModalContext.Provider value={value}>
      {children}
      {opened && <TableProfilesModal opened onClose={close} {...params!} />}
    </TableProfilesModalContext.Provider>
  );
}

/**
 * Hook for marking the device's fault as fixed.
 */
export function useTableProfilesModal() {
  return useContext(TableProfilesModalContext);
}
